export default "__VITE_ASSET__CwGR5AfH__"